import React from 'react'
import { useParams } from 'react-router-dom'
import { z } from 'zod'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { ContextProps } from '../types/types'

// components
import MyPassPage from '../pages/MyPassPage/MyPassPage'

// hooks
import useZodQueryParams from '../hooks/useZodQueryParams'

const myPassPageQuerySchema = z.object({})

type MyPassRouteParams = {
	passID: string
}

const MyPassRoute: React.FC<React.PropsWithChildren<ContextProps>> = (props) => {
	const { passID } = useParams<MyPassRouteParams>()

	const [query, setQuery] = useZodQueryParams(myPassPageQuerySchema)

	if (!passID) {
		return (
			<HttpStatus status={404} {...props}>
				{null}
			</HttpStatus>
		)
	}

	return <MyPassPage {...props} passID={passID} query={query} setQuery={setQuery} />
}

export default MyPassRoute
